/**
 * UrlFieldType — link. Storage: PG TEXT.
 */

import type { FieldInputProps, FieldTypeDefinition } from '../FieldRegistry';

function UrlInput({ field, value, onChange, error, disabled, autoFocus }: FieldInputProps) {
  return (
    <input
      type="url"
      value={typeof value === 'string' ? value : ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      autoFocus={autoFocus}
      placeholder="https://..."
      aria-invalid={!!error}
      data-testid={`field-${field.slug}-input`}
      className="w-full rounded-md border border-border-primary bg-bg-primary px-3 py-2 text-sm text-text-primary placeholder-text-muted focus:border-accent-500 focus:outline-none focus:ring-1 focus:ring-accent-500 disabled:opacity-50"
    />
  );
}

export const UrlFieldType: FieldTypeDefinition = {
  type: 'url',
  renderInput: (props) => <UrlInput {...props} />,
  renderCell: (_field, value) => {
    if (typeof value !== 'string' || !value) return '';
    return (
      <a
        href={value}
        target="_blank"
        rel="noopener noreferrer"
        className="text-accent-600 underline hover:text-accent-700"
        onClick={(e) => e.stopPropagation()}
      >
        {value}
      </a>
    );
  },
  validate: (value) => {
    if (typeof value !== 'string' || value.trim() === '') return null;
    try {
      new URL(value);
      return null;
    } catch {
      return 'invalid_url';
    }
  },
  defaultValue: '',
};
